"use client"

import { useCountry } from "@/components/layout/country-provider"
import { DutchFlagIcon, SwissShieldIcon } from "@/components/ui/icons"

/**
 * Icon for the "reviewed by physicians" trust badge. Market-aware: NL shows the
 * Dutch flag; every other market keeps the Swiss shield, matching each market's
 * "Swiss physicians" positioning. Mirrors `SwissShieldIcon`'s prop signature so
 * it drops straight into the same direct usage and `{ Icon, size }` trust-signal
 * arrays.
 */
export function ReviewedByPhysiciansIcon({
  className,
  size = 28,
}: {
  className?: string
  size?: number
}) {
  const { code } = useCountry()
  const Icon = code === "nl" ? DutchFlagIcon : SwissShieldIcon
  return <Icon className={className} size={size} />
}
